import React, { useState, useContext } from 'react';
import { Card, CardContent, Typography, IconButton, Collapse, Box } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { UserContext } from '../UserAndProfile/UserContext';
import StudentInviteForm from './StudentInviteForm';
import StudentProgressDisplay from './StudentProgressDisplay';
import { getLinkedStudentRef } from '../StudyPlan/studyPlanUtils';

const StudentTrackingCard: React.FC = () => {
  const { user } = useContext(UserContext);
  const [isExpanded, setIsExpanded] = useState(true);

  if (!user || user.userRole !== 'parent') {
    return null;
  }

  const linkedStudent = getLinkedStudentRef(user);
  const pendingInvite = user.referredUsers?.find(r => r.role === 'student' && r.referralStatus === 'invited');

  return (
    <Card sx={{ height: 'fit-content', minHeight: '250px', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: 1 }}>
        <Box sx={{ mb: 2 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
            <Typography variant="h6" component="h2" color="primary.main" gutterBottom>
              Student Progress
            </Typography>
            <IconButton onClick={() => setIsExpanded(!isExpanded)} size="small">
              {isExpanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {!linkedStudent && !pendingInvite
              ? "Invite your student to connect accounts and track their SAT prep progress."
              : linkedStudent
                ? `Monitoring ${linkedStudent.firstName}'s weekly activity and improvement.`
                : `Invitation sent — waiting for ${pendingInvite?.firstName} (${pendingInvite?.email}) to sign up.`}
          </Typography>
        </Box>

        <Collapse in={isExpanded}>
          <Box>
            {linkedStudent ? (
              <StudentProgressDisplay />
            ) : pendingInvite ? (
              <Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Invited: {new Date(pendingInvite.invitedDate).toLocaleDateString()}
                </Typography>
                <Typography variant="body2" color="warning.main">
                  Waiting for student to sign up...
                </Typography>
              </Box>
            ) : (
              <StudentInviteForm />
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default StudentTrackingCard;
